import { FC } from 'react'
import { useNavigationV3Context } from 'components/NavigationV3/hooks/useNavigationV3Context'
import {
  Text,
  GreyGrey70,
  Primary13Regular,
  Primary20SemiBold,
  LineHeights24,
  Flex
} from '@sequencehq/core-components'
import { WorkspaceAvatar } from 'components/NavigationV3/components/WorkspaceAvatar/WorkspaceAvatar'

export const HomeHeader: FC = () => {
  const {
    data: { workspaceName, userEmail }
  } = useNavigationV3Context()

  return (
    <Flex alignItems="center" gap="16px">
      <WorkspaceAvatar workspaceName={workspaceName} />

      <Flex direction="column" gap="4px">
        <Text
          textStyle="sectionHeader"
          {...Primary20SemiBold}
          lineHeight={LineHeights24}
        >
          Welcome back, {workspaceName}
        </Text>

        <Text color={GreyGrey70} {...Primary13Regular}>
          Logged in as {userEmail}
        </Text>
      </Flex>
    </Flex>
  )
}
